import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AssetSearchCriteria } from '../shared/asset-search-criteria.model';
import { AssetService } from '../shared/asset.service';
import { DataTableColumn } from '../../shared/data-table/data-table.component';
import { SortDirection } from '../../shared/sort-direction';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { LoaderService } from '../../shared/services/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../shared/services/modal.service';
import { NavigationLinkService } from '../../shared/services/navigation-link.service';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss']
})
export class AssetListComponent implements OnInit {

  filters: AssetSearchCriteria = {};

  @ViewChild('locationColumn', { static: true})
  locationColumn: TemplateRef<any>;

  @ViewChild('userEmailColumn', { static: true})
  userEmailColumn: TemplateRef<any>;

  @ViewChild('companyNameColumn', { static: true})
  companyNameColumn: TemplateRef<any>;

  @ViewChild('reportedAtColumn', { static: true})
  reportedAtColumn: TemplateRef<any>;

  @ViewChild('productColumn', { static: true})
  productColumn: TemplateRef<any>;

  @ViewChild('quantityColumn', { static: true})
  quantityColumn: TemplateRef<any>;

  @ViewChild('shipmentsColumn', { static: true})
  shipmentsColumn: TemplateRef<any>;

  @ViewChild('vehicleColumn', { static: true})
  vehicleColumn: TemplateRef<any>;

  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  startDate: Moment;
  endDate: Moment;
  public canAccessLoadManagementScreen = false;

  loadPage = (page: number, pageSize: number, sortColumn: DataTableColumn, direction: SortDirection) =>
    this.assetService.search(page - 1, pageSize, sortColumn.name, direction, this.filters);

  constructor(
    private assetService: AssetService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    public translate: TranslateService,
    private modal: ModalService,
    public link: NavigationLinkService,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    const reportedAtColumn = {
      name: 'reported_at',
      displayed: true,
      translationKey: 'assets.reported-at',
      template: this.reportedAtColumn,
      sortable: true
    };

    this.columns = [
      reportedAtColumn,
      {
        name: 'location',
        displayed: true,
        translationKey: 'assets.list.table.location',
        template: this.locationColumn,
        sortable: false
      },
      {
        name: 'user_email',
        displayed: true,
        translationKey: 'assets.user-email',
        template: this.userEmailColumn,
        sortable: true
      },
      {
        name: 'carrier_name',
        displayed: true,
        translationKey: 'assets.carrier_name',
        template: this.companyNameColumn,
        sortable: false
      },
      {
        name: 'product',
        displayed: true,
        translationKey: 'assets.product',
        template: this.productColumn,
        sortable: false
      },
      {
        name: 'quantity',
        displayed: true,
        translationKey: 'assets.quantity',
        template: this.quantityColumn,
        sortable: false
      },
      {
        name: 'shipment_number',
        displayed: true,
        translationKey: 'assets.shipment_number',
        template: this.shipmentsColumn,
        sortable: false
      },
      {
        name: 'vehicle',
        displayed: true,
        translationKey: 'assets.vehicle',
        template: this.vehicleColumn,
        sortable: false
      },
    ];

    this.sortColumn = reportedAtColumn;

    this.route.queryParams
      .pipe(take(1))
      .subscribe(params => {
        if (params.reportedAtStart && params.reportedAtStart !== 'Invalid date') {
          this.startDate = moment(params.reportedAtStart);
          this.updateStartDateFilter();
        }
        if (params.reportedAtEnd && params.reportedAtEnd !== 'Invalid date') {
          this.endDate = moment(params.reportedAtEnd);
          this.updateEndDateFilter();
        }

        this.filters.glid      = params.glid;
        this.filters.userEmail = params.userEmail;
      });

    this.canAccessLoadManagementScreen = this.authenticationService.canViewLoadsManagement();
  }

  pageLoaded() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.filters
      });
  }

  updateStartDateFilter() {
    if (this.startDate) {
      this.filters.reportedAtStart = this.startDate.startOf('day').toISOString();
    } else {
      this.filters.reportedAtStart = null;
    }
  }

  updateEndDateFilter() {
    if (this.endDate) {
      this.filters.reportedAtEnd = this.endDate.endOf('day').toISOString();
    } else {
      this.filters.reportedAtEnd = null;
    }
  }

  openConfirmExportAssets(content) {
    this.modal.open({
      title: this.translate.instant('assets.modals.export.title'),
      content,
      validateButton: {
        text: this.translate.instant('assets.list.filters.export'),
        icon: 'fa fa-download'
      },
      closeButton: {
        text: this.translate.instant('assets.modals.export.close'),
      },
      size: 'sm'
    }).subscribe(() => this.exportAssets());
  }

  exportAssets() {
    this.loader.startLoadAndCloseWhenComplete(
      this.assetService.exportAssets(this.filters)
    ).subscribe();
  }
}
